"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carouselSchema = void 0;
/* eslint-disable camelcase */
const zod_1 = require("zod");
const base_1 = require("../base");
const cardSchema = zod_1.z.object({
    header: zod_1.z.object({
        imageURL: zod_1.z.string(),
    }),
    button: zod_1.z.union([
        zod_1.z.object({
            type: zod_1.z.literal("url"),
            url: zod_1.z.string(),
        }),
        zod_1.z.object({
            type: zod_1.z.literal("text"),
            text: zod_1.z.string(),
        }),
    ]),
});
exports.carouselSchema = zod_1.z
    .object({
    kind: zod_1.z.literal("carousel"),
    cards: zod_1.z.array(cardSchema),
    name: zod_1.z.string(),
})
    .merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.literal("bot") }));
//# sourceMappingURL=carousel.js.map